/* eslint-disable */
import React, { forwardRef, useRef, useEffect, useState, useImperativeHandle, useCallback } from 'react';
import cls from 'classnames';
import ReactIdSwiper from 'react-id-swiper';
import { Swiper } from 'swiper/dist/js/swiper.esm';
import isDefined from '@dcode/is/defined/defined';
import DataLayer from '~/components/DataLayer';
import V360Thumbnail from './V360Thumbnail';

export const V360Versions = forwardRef(({
	className,
	classes,
	mobile,
	list,
	currentType,
	onChange:onChangeCallback,
	...props
}, ref) => {
	const rootRef = useRef();
	const [currentIndex, setCurrentIndex] = useState(0);
	const [swiperThumbsRef, updateSwiperThumbs] = useState(null);
	const [currentDevice] = useState(mobile ? 'mobile' : 'desktop');

	const [swiperThumbsConfigDesktop] = useState({
		direction: mobile ? 'horizontal' : 'vertical',
		rebuildOnUpdate: false,
		centerInsufficientSlides: true,
		loopFillGroupWithBlank: true,
		loop: false,
		freeMode: false,
		grabCursor: true,
		centeredSlides: false,
		initialSlide: currentIndex,
		slidesPerGroup: 1,
		slidesPerView: mobile ? 6 : 4,
		slidesPerColumn: 1,
		spaceBetween: 10,
	});

	const [swiperThumbsConfigTablet] = useState({
		...swiperThumbsConfigDesktop,
		centeredSlides: false,
		slidesPerView: 4,
		slidesPerGroup: 1,
		slidesPerColumn: 1,
		spaceBetween: 18,
		cssMode: true,
	});

	const [swiperThumbsConfigSmartphone] = useState({
		...swiperThumbsConfigDesktop,
		direction: 'horizontal',
		centeredSlides: false,
		slidesPerView: 3,
		slidesPerGroup: 1,
		slidesPerColumn: 1,
		spaceBetween: 20,
		cssMode: true,
	});

	const nextSlide = ((speed, runCallbacks) => {
		if (swiperThumbsRef) {
			swiperThumbsRef.slideNext(speed, runCallbacks);
		}
	});

	const prevSlide = ((speed, runCallbacks) => {
		if (swiperThumbsRef) {
			swiperThumbsRef.slidePrev(speed, runCallbacks);
		}
	});

	const slideTo = ((index, speed, runCallbacks, internal) => {
		if (swiperThumbsRef) {
			// swiperThumbsRef.slideTo(index, speed, runCallbacks, internal);
			setCurrentIndex(index);
		}
	});

	const onChange = (() => {
		if (swiperThumbsRef) {
			// setCurrentIndex(swiperThumbsRef.realIndex);
		}
	});

	const onResize = (() => {
		/*if (swiperThumbsRef) {
			swiperThumbsRef.update();
		}*/
	});

	const toggleEvents = ((type) => {
		if (swiperThumbsRef && swiperThumbsRef.eventsListeners) {
			swiperThumbsRef[type]('slideChange', onChange);
			//swiperThumbsRef[type]('resize', onResize);
		}
	});

	const renderItem = (item, index) => {
		const isCurrentADoubleCabin = item.length === 2 && index === currentIndex && isDefined(currentType);
		const itemData = item[isCurrentADoubleCabin ? currentType : 0][currentDevice];
		console.log(itemData.name);
		return (
			<div key={index} className={cls(classes.thumbItem)}>
				<DataLayer onEvent={'VersionsPage_SelecionouVersaoCarro'} args={[itemData.name]}>
					<V360Thumbnail
						data={itemData}
						onClick={() => slideTo(index)}
						active={index === currentIndex}
					/>
				</DataLayer>
			</div>
		);
	};

	const renderList = (list) => {
		return list.length && list.map(renderItem);
	};

	useEffect(() => onChangeCallback(currentIndex), [currentIndex]);
	//useEffect(onResize, [mobile]);

	useEffect(() => {
		toggleEvents('on');
		return () => toggleEvents('off');
	}, [swiperThumbsRef]);

	useImperativeHandle(ref, () => ({
		root: rootRef.current,
		resize: onResize,
		//nextSlide,
		//prevSlide,
		slideTo,
	}));

	return (
		<section
			ref={rootRef}
			{...props}
			className={cls(classes.root, className)}>
			<div className={cls(classes.thumb)}>
				<ReactIdSwiper
					containerClass={cls(classes.thumbList)}
					Swiper={Swiper}
					getSwiper={updateSwiperThumbs}
					{...swiperThumbsConfigDesktop}
					breakpoints={{
						568: {
							...swiperThumbsConfigSmartphone,
						},
						767: {
							...swiperThumbsConfigSmartphone,
						},
						768: {
							...swiperThumbsConfigTablet,
						},
					}}
					>
					{renderList(list)}
				</ReactIdSwiper>
			</div>
		</section>
	);
});

export default React.memo(V360Versions);
